import moment from 'moment';
import React from 'react';
import Rating from '../Rating/Rating';
import DOMPurify from 'dompurify';

export default class App extends React.Component {
  state = {
    displayAllText: false,
  };

  handleDisplayMoreAction = () => {
    this.setState({ displayAllText: true });
  };

  render() {
    const { singleReview, authorRating, reviewDisplayTextLength } = this.props;
    const reviewAuthorFirstName = singleReview
      ? singleReview?.client.nom
      : '';
    const reviewAuthorLastName = singleReview
      ? singleReview?.client.prenom
      : '';
    const authorName = reviewAuthorFirstName + ' ' + reviewAuthorLastName;
    
    const content = singleReview ?  DOMPurify.sanitize(singleReview.message) : '';
    const isMoreContent = content.length > reviewDisplayTextLength;
    const reviewTitle = singleReview ? singleReview.titre : '';
    const commentDate = singleReview ? singleReview.date : '';
    const authorAvatar = '/images/user-placeholder.png';
    const reviewRating = singleReview && singleReview.note ? [{
      note : singleReview.note
    }] : [];

    return (
      <div className="comment-area">
        <div className="comment-wrapper">
          <div className="comment-header">
            <div className="avatar-area">
              <div className="author-avatar">
                <img src={authorAvatar} alt={authorName} />
              </div>
              <div className="author-info">
                <h3 className="author-name">{authorName}</h3>
                {authorRating && (
                  <div className="author-rating">{authorRating}</div>
                )}
                <div className="comment-date">
                  <span>
                    {moment(commentDate).format('dddd [le]')[0].toLocaleUpperCase()}
                    {moment(commentDate).format(
                      'dddd [le] Do MMMM YYYY'
                    ).slice(1)}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="comment-body">
            <h4>{reviewTitle}</h4>
            <p>
              <span
                dangerouslySetInnerHTML={{
                  __html: content.substring(
                    0,
                    !this.state.displayAllText
                      ? reviewDisplayTextLength
                      : content.length
                  ),
                }}
              ></span>
              {isMoreContent && !this.state.displayAllText && <span>...</span>}
              {isMoreContent && !this.state.displayAllText && (
                <span
                  onClick={() => this.handleDisplayMoreAction('review')}
                  className="libelle-diplay-more"
                >
                  {' '}
                  Voir plus
                </span>
              )}
            </p>
          </div>
          <div className="comment-rating">
            {reviewRating && reviewRating.length !== 0
              ? reviewRating.map((singleReviewRating, i) => {
                  return (
                    <div className="rating-widget" key={i}>
                      <Rating key={i} rating={singleReviewRating.note} />
                    </div>
                  );
                })
              : ''}
          </div>
        </div>
      </div>
    );
  }
}
